import moment from 'moment';

export function fetchPaymentDetails(state, { page, sort, filter }) {
  return {
    ...state,
    payments: {
      ...state.payments,
      isFetching: true,
      sort: sort || state.payments.sort,
      currentPage: page,
      filter: filter || state.payments.filter,
    },
  };
}

export function fetchPaymentDetailsSuccess(state, payments) {
  return {
    ...state,
    payments: {
      ...state.payments,
      isFetching: false,
      numberOfPages: payments.numberOfPages,
      count: payments.count,
      items: payments.items,
    },
  };
}

export function fetchPaymentDetailsFail(state) {
  return {
    ...state,
    payments: {
      ...state.payments,
      isFetching: false,
    },
  };
}

export function fetchPaymentsTotalBalanceSuccess(state, { totalBalance }) {
  return {
    ...state,
    payments: {
      ...state.payments,
      totalBalance: totalBalance.toFixed(2),
    },
  };
}

export function updatePaymentSuccess(state, { payment }) {
  const paymentIndex = state.payments.items.findIndex(({ _id }) => _id === payment._id);
  return {
    ...state,
    payments: {
      ...state.payments,
      items: [
        ...state.payments.items.slice(0, paymentIndex),
        {
          ...payment,
        },
        ...state.payments.items.slice(paymentIndex + 1),
      ],
    },
  };
}

export function showRefreshBalance(state) {
  return {
    ...state,
    payments: {
      ...state.payments,
      showRefreshModal: true,
    },
  };
}

export function hideRefreshBalance(state) {
  return {
    ...state,
    payments: {
      ...state.payments,
      showRefreshModal: false,
    },
  };
}

export function getPeriodsSuccess(state, { periods }) {
  const toDate = (period) => moment(period, 'MMMM YYYY');
  return {
    ...state,
    payments: {
      ...state.payments,
      periods: periods.sort((p1, p2) => {
        if (toDate(p1).isBefore(toDate(p2))) {
          return 1;
        }
        return -1;
      }),
    },
  };
}

export function setRefreshDate(state, { refreshDate }) {
  return {
    ...state,
    payments: {
      ...state.payments,
      refreshDate,
    },
  };
}

export function refreshBalance(state) {
  return {
    ...state,
    payments: {
      ...state.payments,
      isFetching: true,
      message: '',
    },
  };
}

export function refreshBalanceFail(state) {
  return {
    ...state,
    payments: {
      ...state.payments,
      isFetching: false,
      message: 'Sorry, something went wrong. Please note that the numbers displayed might not be fully up to date.',
    },
  };
}

export function setNextPaymentCycle(state, { nextPaymentCycle }) {
  return {
    ...state,
    payments: {
      ...state.payments,
      nextPaymentCycle,
    },
  };
}

export function processPayments(state, { file, process }) {
  return {
    ...state,
    payments: {
      ...state.payments,
      uploading: !process,
      processing: process,
    },
  };
}

export function processPaymentsSuccess(state, { response, process }) {
  return {
    ...state,
    payments: {
      ...state.payments,
      numberOfSuccess: response.numberOfSuccess,
      numberOfFail: response.numberOfFail,
      numberOfNotUpdated: response.numberOfNotUpdated,
      uploading: false,
      processing: false,
      uploaded: !process,
      processed: process,
    },
  };
}



/** WEBPACK FOOTER **
 ** ./js/core/payments.js
 **/